import { useEffect } from "react";
import { setupInterceptor, axiosInstance } from "./axiosApiInstance";
import { useSessionExpiry } from "./SessionExpiryContext";

/**
 * Component that sets up the axios interceptor with session expiry handling.
 * Must be rendered inside both SessionExpiryProvider and Router contexts.
 */
export const SessionExpirySetup = () => {
  const { showSessionExpired } = useSessionExpiry();

  useEffect(() => {
    const interceptor = setupInterceptor(showSessionExpired);

    return () => {
      // Cleanup interceptor on unmount
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [showSessionExpired]);

  return null;
};
